import { RouterModule, Routes } from '@angular/router';
import { GraphicDesignComponent} from './pages/graphic-design/graphic-design.component';
import { AdemasComponent} from './pages/ademas/ademas.component';
import { VideoComponent} from './pages/video/video.component';
import { WebDesignComponent} from './pages/web-design/web-design.component';
import { PagesComponent } from './pages/pages.component';
import { PrincipalComponent } from './principal/principal.component';
import { SobremiComponent} from './pages/sobremi/sobremi.component';
import { DetalleComponent } from './pages/detalle/detalle.component';
import { DetalleWebComponent } from './pages/detalle-web/detalle-web.component';
import { DetalleVideoComponent} from './pages/detalle-video/detalle-video.component';
import { DetalleMoreComponent } from './pages/detalle-more/detalle-more.component';



const appRoutes: Routes = [
  {path: '', component: PagesComponent, children: [
    {path: 'graphic-design', component: GraphicDesignComponent},
    {path: 'more', component: AdemasComponent },
    {path: 'video', component: VideoComponent },
    {path: 'web-design', component: WebDesignComponent },
    {path: 'about-me', component: SobremiComponent },
    {path: 'detail-graphic-design/:id', component: DetalleComponent},
    {path: 'detail-web/:id', component: DetalleWebComponent},
    {path: 'detail-video/:id', component: DetalleVideoComponent},
    {path: 'detail-more/:id', component: DetalleMoreComponent},
    {path: '', redirectTo: '/principal', pathMatch: 'full'},
  ]},
  {path: 'principal', component: PrincipalComponent}
];


export const APP_ROUTES = RouterModule.forRoot(appRoutes, {useHash: true});
